/**
 * #2029 — a stored `ride.placing` of 0 is real data meaning UNPLACED (FVD's
 * "not yet placed" sentinel), never a literal 0-index. `rank` elsewhere is
 * already `index + 1`; this helper must never add 1 to `placing` anywhere,
 * that would corrupt a real placing.
 *
 * Decision recorded on the card (2026-08-30, comment): an absent placing
 * (null/undefined, e.g. the class hasn't been placed yet) renders IDENTICALLY
 * to a stored 0 (explicitly evaluated and not placed). Both states already
 * collapsed to one dash under the pre-#2029 `??` fallback for every case
 * except the 0 leak this card fixes, so keeping them visually unified matches
 * the surrounding UI's established convention rather than teaching the
 * reader a new three-way distinction. The composite score and ride status
 * badge next to the placing already carry whatever "has scoring finished"
 * signal the reader needs; the placing cell only needs to answer "is there a
 * placing number to show".
 *
 * @param {Function} t - i18next translation function (useTranslation("scoreadmin"))
 * @param {number|null|undefined} placing
 * @returns {string}
 */
export function formatPlacing(t, placing) {
  if (placing == null || placing === 0) return t("common.unplacedPlacing");
  return String(placing);
}
